import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../config.json";
import { mainAxios } from "../app/api";
import { errorToast, successToast } from "../helpers/toaster";
import { checkStatus } from "../helpers/helper";
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};
const {
  userLogin,
  userRegister,
  resendOtp,
  varifyEmail,
  forgotPassword,
  varifyAndChange,
  userProfileUpdate,
  sendOtpEmail,
  saveNewEmail,
  saveNewPassword,
  checkEmail,
  notification,
} = service;

const initialState = {
  userData: [],
  loading: false,
  errors: [],
  secret_key: "",
  resend: false,
  loginStatus: "",
  varified: "",
  forgotApproved: false,
  updatePassword: "",
  resetEmailStatus: false,
  emailExist: false,
  registerStatus: false,
  otp: false,
  notification: [],
  recallApi: false,
};

const updateLocalStorage = (vals) => {
  vals?.length > 0
    ? sessionStorage.setItem("userData", JSON.stringify(vals[0].data))
    : sessionStorage.removeItem("userData");
};

export const userLoginAsync = createAsyncThunk(
  "user/userLoginAsync",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const res = await mainAxios.post(userLogin, {
        email,
        password,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response);
      // const { response } = err;

      // return response.data;
    }
  }
);

export const resendOtpAsync = createAsyncThunk(
  "user/resendOtpAsync",
  async (state) => {
    try {
      const res = await mainAxios.post(resendOtp, { secret_key: state });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const forgotPasswordAsync = createAsyncThunk(
  "user/forgotPasswordAsync",
  async (state) => {
    try {
      const res = await mainAxios.post(forgotPassword, { email: state });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const varifyAndChangeAsync = createAsyncThunk(
  "user/varifyAndChangeAsync",
  async (state) => {
    const { password, otp, key } = state;
    try {
      const res = await mainAxios.post(varifyAndChange, {
        varify_code: otp,
        password: password,
        secret_key: key,
      });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const varifyEmailAsync = createAsyncThunk(
  "user/varifyEmailAsync",
  async ({ OTP, key }) => {
    try {
      const res = await mainAxios.post(varifyEmail, {
        varify_code: OTP,
        secret_key: key,
      });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);
// sendOtpEmailAsync
export const sendOtpEmailAsync = createAsyncThunk(
  "user/sendOtpEmailAsync",
  async ({ email, Authorization }) => {
    try {
      const res = await mainAxios.post(
        sendOtpEmail,
        {
          email,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const saveNewEmailAsync = createAsyncThunk(
  "user/saveNewEmailAsync",
  async ({ email, Authorization, OTP }) => {
    try {
      const res = await mainAxios.post(
        saveNewEmail,
        {
          email,
          varify_code: OTP,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

// resetPasswordAsync
export const resetPasswordAsync = createAsyncThunk(
  "user/resetPasswordAsync",
  async ({ password, Authorization }) => {
    try {
      const res = await mainAxios.post(
        saveNewPassword,
        {
          password,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

// checkEmailAsync
export const checkEmailAsync = createAsyncThunk(
  "user/checkEmailAsync",
  async (email) => {
    try {
      const res = await mainAxios.post(checkEmail, {
        email,
      });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const userRegisterAsync = createAsyncThunk(
  "user/userRegisterAsync",
  async (state) => {
    const {
      FirstName,
      LastName,
      Dob,
      Gender,
      Email,
      MobileNo,
      Nationality,
      CountryCode,
      Password,
    } = state;
    try {
      const res = await mainAxios.post(userRegister, {
        firstName: FirstName,
        lastName: LastName,
        dob: Dob,
        gender: Gender,
        email: Email,
        mobile: MobileNo,
        nationality: Nationality,
        countryCode: CountryCode,
        password: Password,
      });
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

// updateProfileAsync
export const updateProfileAsync = createAsyncThunk(
  "user/updateProfileAsync",
  async (val) => {
    const { Authorization, state } = val || {};
    const {
      FirstName,
      LastName,
      Dob,
      Gender,
      MobileNo,
      Nationality,
      CountryCode,
    } = state;
    try {
      const res = await mainAxios.post(
        userProfileUpdate,
        {
          firstName: FirstName,
          lastName: LastName,
          dob: Dob,
          gender: Gender,
          mobile: MobileNo,
          nationality: Nationality,
          countryCode: CountryCode,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const getNotificationAsync = createAsyncThunk(
  "user/notification",
  async (Authorization) => {
    try {
      const res = await mainAxios.post(
        notification,
        {},
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

export const ClearNotificationAsync = createAsyncThunk(
  "user/notification",
  async (Authorization) => {
    try {
      const res = await mainAxios.post(
        notification,
        { clearData: true },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state.userData = [];
      state.errors = [];
      state.loginStatus = false;
      successToast("Logged Out Successfully!");
      // sessionStorage.setItem("hotelForm", "");
      updateLocalStorage([]);
    },
    setUser: (state, { payload }) => {
      state.userData = payload;
    },
    resetKey: (state) => {
      state.secret_key = "";
    },
    resetUpdatePassword: (state) => {
      state.updatePassword = "";
    },
    resetResend: (state) => {
      state.resend = false;
    },
    resetForgot: (state) => {
      state.forgotApproved = false;
    },
    resetVarified: (state) => {
      state.varified = false;
    },
    resetErrors: (state) => {
      state.errors = {};
    },
    removeEmailStatus: (state) => {
      state.resetEmailStatus = false;
    },
    resetRegisterStatus: (state) => {
      state.registerStatus = false;
    },
  },
  extraReducers: {
    [userLoginAsync.pending]: (state) => {
      return {
        ...state,
        loading: true,
        loginStatus: "",
        errors: [],
        varified: "",
      };
    },
    [userLoginAsync.fulfilled]: (state, { payload }) => {
      if (payload.success === true) {
        updateLocalStorage([payload]);
        successToast(payload.message);
        return {
          ...state,
          userData: payload?.data,
          loginStatus: true,
          secret_key: "",
          loading: false,
        };
      } else {
        if (Object.keys(payload.data).length === 0) {
          errorToast(payload.message);
        }
        // else{
        return {
          ...state,
          errors: [payload],
          secret_key: payload.data,
          loginStatus: false,
          loading: false,
          varified: false,
        };
        // }
      }
    },
    [userLoginAsync.rejected]: (state, { payload }) => {
      errorToast(checkStatus(payload?.status, payload?.message));
      return {
        ...state,
        loading: true,
        userData: [],
      };
    },
    [userRegisterAsync.pending]: (state) => {
      return { ...state, loading: true, registerStatus: false, varified: "" };
    },
    [userRegisterAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("User Registered Successfully!");
        return {
          ...state,
          secret_key: payload.data.secret_key,
          varified: false,
          loading: false,
          registerStatus: true,
        };
      } else {
        // errorToast()
        payload?.errors.map((ele) => {
          errorToast(ele.msg);
        });
        return {
          ...state,
          errors: payload,
          loading: false,
          registerStatus: false,
        };
      }
    },
    [resendOtpAsync.pending]: (state) => {
      return { ...state, loading: true, resend: false };
    },
    [resendOtpAsync.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        successToast(payload.message);
        return {
          ...state,
          resend: true,
          loading: false,
        };
      } else {
        return { ...state, errors: payload, loading: false };
      }
    },
    [varifyEmailAsync.pending]: (state) => {
      return { ...state, loading: true, errors: [] };
    },
    [varifyEmailAsync.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        successToast("Logged In Successfully!");
        return {
          ...state,
          userData: payload?.data,
          loginStatus: true,
          secret_key: "",
          varified: true,
          loading: false,
          otp: true,
        };
        // return {
        //   ...state,
        //   varified: true,
        //   secret_key: payload.data.secret_key,
        //   loading: false,
        // };
      } else {
        errorToast(payload.message);
        return {
          ...state,
          varified: false,
          errors: [payload],
          loading: false,
          loginStatus: false,
          otp: false,
        };
      }
    },
    [forgotPasswordAsync.pending]: (state) => {
      return { ...state, loading: true, forgotApproved: false };
    },
    [forgotPasswordAsync.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        return {
          ...state,
          forgotApproved: true,
          secret_key: payload.data.secret_key,
          loading: false,
        };
      } else {
        errorToast(payload.errors[0].msg);
        return {
          ...state,
          forgotApproved: false,
          // errors: payload,
          loading: false,
        };
      }
    },
    [varifyAndChangeAsync.pending]: (state) => {
      return { ...state, loading: true, updatePassword: "" };
    },
    [varifyAndChangeAsync.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        return {
          ...state,
          updatePassword: true,
        };
      } else {
        errorToast(payload.message);
        return { ...state, updatePassword: false };
      }
    },
    [updateProfileAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [updateProfileAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("Profile Updated Successfully!");
        // updateLocalStorage([payload?.data?.user]);
        sessionStorage.setItem("userData", JSON.stringify(payload?.data));
        return {
          ...state,
          loading: false,
          userData: payload?.data,
        };
      } else {
        errorToast(payload.message);
        return { ...state, loading: false };
      }
    },
    [sendOtpEmailAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [sendOtpEmailAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast(payload?.message);
        return { ...state, resetEmailStatus: true, loading: false };
      } else {
        errorToast(payload?.message);
        return { ...state, resetEmailStatus: false, loading: false };
      }
    },
    [saveNewEmailAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [saveNewEmailAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("Email Varified Successfully!");
        sessionStorage.setItem("userData", JSON.stringify(payload?.data));
        return { ...state, loading: false, userData: payload?.data };
      } else {
        errorToast("Invalid Verification Code!");
        return { ...state, loading: false };
      }
    },
    [resetPasswordAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [resetPasswordAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("Password Changed Successfully!");
        return { ...state, loading: false };
      } else {
        errorToast("Password Not Changed!");
        return { ...state, loading: false };
      }
    },
    [checkEmailAsync.pending]: (state) => {
      return { ...state, emailExist: false };
    },
    [checkEmailAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, errors: { Email: payload?.message } };
        // errorToast(payload?.message);
      } else {
        return { ...state, errors: { Email: payload?.message } };
      }
    },
    [getNotificationAsync.pending]: (state) => {
      return { ...state, notification: [] };
    },
    [getNotificationAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, notification: payload.data };
        // errorToast(payload?.message);
      } else {
        //return { ...state, errors: { Email: payload?.message } };
      }
    },
    [ClearNotificationAsync.pending]: (state) => {
      return { ...state };
    },
    [ClearNotificationAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, notification: payload.data };
        // errorToast(payload?.message);
      } else {
        //return { ...state, errors: { Email: payload?.message } };
      }
    },
  },
});

export const getLogin = (state) => {
  if (state.user.userData !== undefined) {
    return state.user.userData;
  }
};

export const getNotification = (state) => {
  if (state.user.notification !== undefined) {
    return state.user.notification;
  }
};

export const getLoginStatus = (state) => {
  if (state.user.loginStatus !== undefined) {
    return state.user.loginStatus;
  }
};

export const getvarified = (state) => {
  if (state.user.varified !== undefined) {
    return state.user.varified;
  }
};

export const getotp = (state) => {
  if (state.user.otp !== undefined) {
    return state.user.otp;
  }
};

export const getUpdatePassword = (state) => {
  return state.user.updatePassword;
};

export const getKey = (state) => {
  return state.user.secret_key;
};

export const getRegisterErrors = (state) => {
  return state.user.errors;
};
// Action creators are generated for each case reducer function
export const {
  setUser,
  logout,
  resetKey,
  resetResend,
  resetUpdatePassword,
  resetForgot,
  resetVarified,
  resetErrors,
  resetRegisterStatus,
  removeEmailStatus,
} = userSlice.actions;

export default userSlice.reducer;
